
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/seizoenseinde-skigebieden",
      function () {
        return require("private-next-pages/[region]/seizoenseinde-skigebieden.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/seizoenseinde-skigebieden"])
      });
    }
  